import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import PaymentMethodChannelItem from './PaymentMethodChannelItem';

function PaymentMethodChannels() {
    const url = '/site/api/payment-method-channels';
    const [paymentMethodChannel, setPaymentMethodChannel] = useState([]);
    const [slidesWidth, setSlidesWidth] = useState(1);
    const [slidesCount, setSlidesCount] = useState(1);
    const [slidesIndex, setSlidesIndex] = useState([]);
    const [sliderSettings, setSliderSettings] = useState({
        mobileFirst: true,
        dots: false,
        infinite: false,
        centerMode: true,
        variableWidth: true,
        autoplaySpeed: 2500,
        slidesToShow: 0,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplay: true,
        swipeToSlide: false,
        draggable: false,
        swipe: false,
    });
    const sliderRef = useRef(null);
    const componentRef = useRef({});
    componentRef.current = {
        slidesWidth,
        slidesCount,
    };

    useEffect(() => {
        getPaymentMethodChannels();
        window.addEventListener('resize', handleSliderWidth, false);
        setSlidesIndex([]);

        return () => {
            window.removeEventListener('resize', handleSliderWidth, false);
        };
    }, []);

    useEffect(() => {
        handleSliderWidth();
        window.addEventListener('resize', handleSliderWidth, false);

        return () => {
            window.removeEventListener('resize', handleSliderWidth, false);
        };
    }, []);

    function getPaymentMethodChannels() {
        axios.get(url).then((response) => {
            const data = response.data;
            setPaymentMethodChannel(data);
        });
    }

    function handleSliderWidth() {
        const width = window.innerWidth;
        const MIN_WIDTH = 320;

        let slidesToShow = 1;
        let slidersActive = false;

        if (width >= MIN_WIDTH) {
            slidersActive = true;
            slidesToShow = Math.floor(width / 100);
        }

        setSliderSettings((prevSettings) => ({
            ...prevSettings,
            slidesToShow,
            autoPlay: slidersActive,
            centerMode: !slidersActive,
            swipeToSlide: slidersActive,
            infinite: false,
        }));
    }

    function getContent() {
        if (paymentMethodChannel.length > 0) {
            return (
                <Slider ref={sliderRef} {...sliderSettings}>
                    {paymentMethodChannel.map((slide, index) => {
                        return (
                            <PaymentMethodChannelItem
                                key={slide.name ?? index}
                                name={slide.name}
                                index={index}
                                logo_url={slide.logo_url}
                                setSlidesWidth={setSlidesWidth}
                                slidesWidth={slidesWidth}
                                slidesCount={slidesCount}
                                setSlidesCount={setSlidesCount}
                                setSlidesIndex={setSlidesIndex}
                                slidesIndex={slidesIndex}
                            />
                        );
                    })}
                </Slider>
            );
        }
        return <></>;
    }
    return getContent();
}

export default PaymentMethodChannels;
